import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { SchemasFactory, ContentFactory, Content } from '../../squidex';
import { Observable } from 'rxjs';
import { AppToken } from '../../../models/app-token';

@Injectable({
    providedIn: 'root'
})
export class SectionService extends BaseService {

    constructor(schemasFactory: SchemasFactory,
      contentFactory: ContentFactory) {
      super(AppToken.SECTION_SCHEMA_NAME, contentFactory);
    }

    getFirstContent(): Observable<Content> {
        this.initialize();
        return this.contentService.getFirstContent();
    }

}
